import request from "@/utils/request";
import { fileService } from "@/api/common/file-utils";

export default {
    dcOutboundList: (param) => {
        return request({
            url: `/rmc/DcOutbound/list`,
            method: "post",
            data: param,
        });
    },
    dataListDownload: (param) => {
        return request({
            url: `/rmc/DcOutbound/dataListDownload`,
            method: "post",
            data: param,
            responseType: "blob",
            fullResponse: true,
        }).then((resp)=>{
            fileService.respToFile(resp, 'DC发货量(RMC月度)_Report.xlsx');
        });
    },
    findCategory: (param) => {
        return request({
            url: `/category/findCategory`,
            method: "post",
            data: param,
        });
    },

};
